export const JOB_INVITE_BULK_INVITE_REQUEST = 'job/invite-bilk-invite-request'
export const JOB_INVITE_BULK_INVITE_SUCCESS = 'job/invite-bilk-invite-success'
export const JOB_INVITE_BULK_INVITE_FAILED = 'job/invite-bilk-invite-failed'
